import { useMemo } from "react";

import QUERY_TAGS from "../search/queryTags";
import useQuery from "../search/useQuery";
import { TAXONOMY_STALE_TIME } from "../search/queryCache";

import {
  ACCESSORY_CODE,
  accessoryMaterials,
  mapCategoryChips,
  resolveAccessoryOption,
} from "./accessoryMappers";
import {
  fetchContainerMaterials,
  fetchContainerOptions,
  fetchProductCategories,
} from "./accessoriesService";

const useAccessoryTaxonomy = () => {
  const options = useQuery({
    key: "accessories:container-options",
    tag: QUERY_TAGS.TAXONOMY_CONTAINER_OPTIONS,
    fetcher: fetchContainerOptions,
    staleTime: TAXONOMY_STALE_TIME,
  });

  const categories = useQuery({
    key: "accessories:product-categories",
    tag: QUERY_TAGS.TAXONOMY_PRODUCT_CATEGORIES,
    fetcher: fetchProductCategories,
    staleTime: TAXONOMY_STALE_TIME,
  });

  const materials = useQuery({
    key: "accessories:container-materials",
    tag: QUERY_TAGS.TAXONOMY_CONTAINER_MATERIALS,
    fetcher: fetchContainerMaterials,
    staleTime: TAXONOMY_STALE_TIME,
  });

  const accessoryOption = useMemo(
    () => resolveAccessoryOption(options.currentData),
    [options.currentData]
  );

  const chips = useMemo(
    () => mapCategoryChips(categories.currentData),
    [categories.currentData]
  );

  const materialOptions = useMemo(
    () =>
      accessoryMaterials(
        materials.currentData,
        accessoryOption?.code || ACCESSORY_CODE
      ),
    [materials.currentData, accessoryOption]
  );

  const optionMissing = options.isSuccess && !accessoryOption;

  const refetch = () => {
    options.refetch();
    categories.refetch();
    materials.refetch();
  };

  return {
    accessoryOption,
    containerOptionId: accessoryOption?.id ?? null,
    chips,
    materials: materialOptions,
    isResolving: !options.isSuccess && !options.isError,
    isReady: Boolean(accessoryOption),
    isError: options.isError || optionMissing,
    optionMissing,
    refetch,
  };
};

export default useAccessoryTaxonomy;
